module.exports = __webpack_public_path__ + "static/media/detail4_angio_pg2.f8f574fd.png";